export default __webpack_public_path__ + "static/media/DBD_logo.8cbda13d.png";